/**
 * SPDX-FileCopyrightText: 2023 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { getLoggerBuilder } from '@nextcloud/logger';
export const logger = getLoggerBuilder()
    .setApp('files_reminders')
    .detectUser()
    .build();
